import React, { memo } from 'react'
import { Row, Col, Input, Form, Button } from 'antd'
import { useMutation } from '@apollo/react-hooks'
import { toast } from 'react-toastify'

import classes from './styles.module.scss'
import { ResendQRCodeForChillPack } from 'store'

const ResendQRCode: React.FunctionComponent<any> = ({ handleResendQRCode }) => {
	const [resendQRCodeForChillPackMutation] = useMutation(
		ResendQRCodeForChillPack,
	)

	const onFinish = (values: { email: string }) => {
		resendQRCodeForChillPackMutation({
			variables: {
				email: values.email,
			},
		})
			.then(
				(response: {
					data?: { resendQRCodeForChillPack: { code: string } }
				}) => {
					if (
						response?.data?.resendQRCodeForChillPack?.code !== '404'
					) {
						handleResendQRCode()
					} else {
						toast.error(
							`Adresa de e-mail nu a fost gasita in sistemul nostru. Te rugam sa te inregistrezi.`,
							{
								position: 'top-center',
								autoClose: 5000,
								hideProgressBar: false,
								closeOnClick: true,
								pauseOnHover: true,
								draggable: true,
							},
						)
					}
				},
			)
			.catch(() => {
				toast.error(`Ne pare rau...ceva nu a functionat corect.`, {
					position: 'top-center',
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
				})
			})
	}

	return (
		<Form
			name="student_kit_recover_qr_code"
			initialValues={{ remember: true }}
			onFinish={onFinish}
		>
			<div className={classes.container}>
				<Row className={classes.row} gutter={8}>
					<Col
						className={classes.column}
						sm={{ span: 24 }}
						md={{ span: 12 }}
					>
						<Form.Item
							name="email"
							rules={[
								{
									type: 'email',
									required: true,
									message: 'Introdu adresa de e-mail.',
								},
							]}
						>
							<Input
								id="email"
								type={'text'}
								placeholder={'E-mail'}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row className={classes.row}>
					<Col
						className={classes.column}
						sm={{ span: 4 }}
						md={{ span: 2 }}
					>
						<div className={classes.saveButton}>
							<Button htmlType={'submit'} type="primary">
								{'Trimite'}
							</Button>
						</div>
					</Col>
				</Row>
			</div>
		</Form>
	)
}

export default memo((props: any) => <ResendQRCode {...props} />)
